import { defineComponent, onBeforeMount, createBlock, openBlock, unref, normalizeClass, withCtx, createVNode } from "vue";
import { Dialog, DialogPanel } from "@headlessui/vue";
import { addScalarClassesToHeadless } from "@scalar/components";
import TypesenseSearch from "./TypesenseSearch.vue.js";
import FlowOverlay from "../../components/FlowOverlay.vue.js";
import { DocumentClasses } from "../../themes/document-classes.js";
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "Search",
  props: {
    showSearch: { type: Boolean },
    typesenseKey: {},
    typesenseHost: {},
    projectId: {}
  },
  emits: ["close"],
  setup(__props, { emit: __emit }) {
    const emit = __emit;
    onBeforeMount(() => addScalarClassesToHeadless());
    return (_ctx, _cache) => {
      return openBlock(), createBlock(unref(Dialog), {
        class: normalizeClass(unref(DocumentClasses).Search),
        open: _ctx.showSearch,
        onClose: _cache[1] || (_cache[1] = ($event) => emit("close"))
      }, {
        default: withCtx(() => [
          createVNode(unref(FlowOverlay), null, {
            default: withCtx(() => [
              createVNode(unref(DialogPanel), { class: "document-search-container" }, {
                default: withCtx(() => [
                  createVNode(TypesenseSearch, {
                    projectId: _ctx.projectId,
                    typesenseHost: _ctx.typesenseHost,
                    typesenseKey: _ctx.typesenseKey,
                    onClose: _cache[0] || (_cache[0] = ($event) => emit("close"))
                  }, null, 8, ["projectId", "typesenseHost", "typesenseKey"])
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["class", "open"]);
    };
  }
});
export {
  _sfc_main as default
};
//# sourceMappingURL=Search.vue.js.map
